export enum UploadType {
  MULTIPLE = 'multiple',
  SINGLE = 'single'
}

export enum UploadValidationType {
  TYPE = 'type',
  EXTENSION = 'extension'
}

export enum BorealUploadType {
  ATTACHMENT_WORKFLOW = 'attachment_workflow',
  NFS_LOGO = 'nfs_logo',
  REPORTS_LOGO = 'reports_logo',
  CERTIFICATE = 'certificate'
}